import React from 'react';
import styles from './Logo.module.scss';
import { Icon } from '../Icon/Icon';

export const Logo = () => <Icon name="logo" className={styles.logo} />;
